import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import httpBackend  from 'i18next-http-backend';

const initPromise = i18next
  .use(initReactI18next)
  .use(httpBackend)
  .init({
    debug: false,
    fallbackLng: "eu",
    backend: {
      loadPath: "/locales/{{lng}}.json"
    },
  });

export { initPromise };
export default i18next;